import React, { cloneElement } from 'react';
import {
  Button,
  Col,
  Row,
  Form,
  Table,
  Label,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
} from 'reactstrap';
import axios from '../utils/posAxios';
import StorageService from '../services/StorageService';
import { MdDone, MdClear, MdCreate, MdSearch } from 'react-icons/md';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import CrmCustomerForm from '../components/CrmCustomerForm';
import PosProductForm from '../components/PosProductForm';
import SearchInput from '../components/SearchInput';
import { BsPlusSquareFill } from 'react-icons/bs';
import { IconContext } from 'react-icons/lib';
import { MDBDataTableV5 } from 'mdbreact';
import '@fortawesome/fontawesome-free/css/all.min.css';
const tbcolumn = [
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
  },

  {
    label: 'Contact',
    field: 'contact',
    sort: 'asc',
  },
  {
    label: 'Email',
    field: 'email',
    sort: 'asc',
  },
  {
    label: 'Serial',
    field: 'serial',
    sort: 'asc',
  },
  {
    label: 'Model',
    field: 'model',
    sort: 'asc',
  },
  {
    label: 'Install Date',
    field: 'install_date',
    sort: 'asc',
  },
  {
    label: 'Unit',
    field: 'unit',
    sort: 'asc',
  },
  {
    label: 'Postal Code',
    field: 'postal_code',
    sort: 'asc',
  },
  {
    label: 'Brand',
    field: 'brand',
    sort: 'asc',
  },
];
class CrmCustomerTable extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      isGlobal: '',
      customerList: [],
      filteredList: [],
      redirect: false,
      selectedId: '',
      selectedData: '',
      searchKey: '',
    };
  }

  componentDidMount() {
    const user = StorageService.getSession('user_info');
    //if (user.superUser) {
    this.getCustomerList();
    // } else {
    //   this.setState({
    //     redirect: true,
    //   });
    // }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  toggle = (action, id) => () => {
    return this.setState({
      modal: !this.state.modal,
      isEdit:
        id != undefined || (id != null && action == 'EDIT') ? true : false,
      selectedId: id != undefined || (id != null && action == 'EDIT') ? id : '',
    });
  };

  closeModal = (title, message, level, reload) => {
    this.notificationSystem.addNotification({
      title: title,
      message: message,
      level: level,
      position: 'br',
      autoDismiss: 2,
      dismissible: 'click',
    });

    this.setState({
      modal: false,
    });

    if (reload) {
      window.location.reload();
    } else {
      this.getCustomerList();
    }
  };

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  sortData() {
    const { customerList, sortKey } = this.state;
    if (sortKey.length) {
      customerList.sort((a, b) => a[sortKey] - b[sortKey]).reverse();
      console.log(customerList);
      this.setState({ customerList });
    } else {
      this.getCustomerList();
    }
  }

  searchChange = event => {
    const searchKey = event.target.value.toLowerCase();
    this.setState({ searchKey }, () => this.filteredList());
  };

  filteredList = () => {
    let customerList = this.state.customerList;
    let searchKey = this.state.searchKey;

    let customers = customerList.filter(customer => {
      return (
        customer.name.toLowerCase().indexOf(searchKey) != -1 ||
        customer.serial.toLowerCase().indexOf(searchKey) != -1 ||
        customer.model.toLowerCase().indexOf(searchKey) != -1 ||
        customer.unit.toLowerCase().indexOf(searchKey) != -1 ||
        customer.postal_code.toLowerCase().indexOf(searchKey) != -1 ||
        customer.install_date.toLowerCase().indexOf(searchKey) != -1
      );
    });
    this.setState({ filteredList: customers });
  };

  getCustomerList = () => {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    };
    axios
      .post(url + ':3004/v1/customer/data', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          this.setState({
            customerList: result.data,
            filteredList: result.data,
          });
        }
      })
      .catch(error => {
        alert(error);
      });
  };

  detail = id => {
    console.log(`/posstore/${this.props.data.store_id}/product` + id);
    this.props.history.push({
      pathname: `/posstore/${this.props.data.store_id}/product/` + id,
    });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }

    const data = {
      columns: tbcolumn,
      rows: this.state.customerList,
    };

    const customerList = this.state.filteredList.map(item => {
      return (
        <tr key={item.customer_id}>
          <td>{item.name}</td>
          <td>{item.contact}</td>
          <td>{item.email}</td>
          <td>{item.serial}</td>
          <td>{item.model}</td>
          <td>{item.install_date}</td>
          <td>{item.unit}</td>
          <td>{item.postal_code}</td>
          {/* <td>
            <div className="ps-action-button">
              <Button
                className="theme-button theme-button-secondary"
                onClick={() => this.props.detail(item.customer_id)}
              >
                View
              </Button>
            </div>
          </td> */}
        </tr>
      );
    });

    return (
      <>
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />

        {/* <Row>
          <Col md={8}>
            <Form inline className="cr-search-form">
              <MdSearch size="20" className="cr-search-form__icon-search" />
              <Input
                type="search"
                className="cr-search-form__input"
                placeholder="Search..."
                value={this.state.searchKey}
                onChange={this.searchChange}
              />
            </Form>
          </Col>

          <Col md={4}>
            <div className="text-right mb-3">
              <div className="ps-btn-group">
                <Button color="link" onClick={this.toggle('ADD', null)}>
                  <IconContext.Provider value={{ color: '#2a2c6b' }}>
                    <BsPlusSquareFill size={25} />
                  </IconContext.Provider>
                </Button>
              </div>
            </div>
          </Col>
        </Row> */}

        <MDBDataTableV5
          className="ps-customerdata-table"
          data={data}
          displayEntries={false}
          noRecordsFoundLabel="No Data"
          searchTop
          searchBottom={false}
          responsive
        />

        {/* <Table responsive hover className="ps-table tb-col-9 th-no-wrap">
          <thead>
            <tr>
              <th>Name</th>
              <th>Contact</th>
              <th>Email</th>
              <th>Serial</th>
              <th>Model</th>
              <th>Install Date</th>
              <th>Unit</th>
              <th>Postal Code</th>
            </tr>
          </thead>
          <tbody>
            {customerList.length < 1 ? (
              <tr>
                <td colSpan="9">
                  <div className="ps-empty-data">
                    <div className="empty-content">
                      <MdCreate />
                      <h4>No data to show</h4>
                      <span>
                        Click the {this.state.isGlobal ? 'Create' : 'Add'}{' '}
                        button to add new product
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            ) : (
              customerList
            )}
          </tbody>
        </Table> */}

        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle()}
          className={this.props.className}
          centered
        >
          <CrmCustomerForm
            history={this.props.history}
            onToggleModal={this.toggle}
            closeModal={this.closeModal}
            match={this.props.match}
            data={this.state}
          />
        </Modal>

        {/* <Modal
          isOpen={this.state.confirmModal}
          toggle={this.toggleConfirmModal()}
          className={this.props.className}
          centered
          style={{ fontSize: '0.85rem' }}
        >
          <ModalHeader toggle={this.toggleConfirmModal()}>
            {this.state.isGlobal ? 'Delete' : 'Remove'} Product
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <p>
                  Are you sure you want to{' '}
                  {this.state.isGlobal ? 'delete' : 'remove'}{' '}
                  {this.state.selectedData} ?
                </p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              className="theme-button theme-button-secondary"
              onClick={this.toggleConfirmModal()}
            >
              Discard
            </Button>
            <Button
              className="theme-button theme-button-primary"
              onClick={() => this.delete()}
            >
              Confirm
            </Button>
          </ModalFooter>
        </Modal> */}
      </>
    );
  }
}
export default CrmCustomerTable;
